import { createContext, useContext, useLayoutEffect } from 'react'

export interface SuspensionValue {
  /** Сообщает «поверх открыто моё окно»; возвращает отмену. */
  register: () => () => void
  suspended: boolean
}

const NOOP_SUSPENSION: SuspensionValue = { register: () => () => undefined, suspended: false }

export const SuspensionContext = createContext<SuspensionValue>(NOOP_SUSPENSION)

export function useParticipantNoticesSuspended(): boolean {
  return useContext(SuspensionContext).suspended
}

/** Страничное окно зовёт это с признаком «я открыто». Без провайдера (тесты,
 *  другие раскладки) — ничего не делает. Layout-эффект: пауза встаёт до
 *  отрисовки, и окно хоста не успевает мигнуть. */
export function useSuspendParticipantNotices(isOpen: boolean) {
  const { register } = useContext(SuspensionContext)
  useLayoutEffect(() => {
    if (!isOpen) return
    return register()
  }, [isOpen, register])
}
